import { render, staticRenderFns } from "./PendingForSubmittedApplicationList.vue?vue&type=template&id=5b17eb05&lang=html&"
import script from "./PendingForSubmittedApplicationList.vue?vue&type=script&lang=js&"
export * from "./PendingForSubmittedApplicationList.vue?vue&type=script&lang=js&"
import style0 from "./PendingForSubmittedApplicationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports